<template>
  <div class="product-item relative-section product-place-item" v-if="room">
    <a :href="room.link" class="image-fit">
      <img v-if="room.image" :src="room.image" alt />
    </a>
    <div class="info-text">
      <h3 class="font-balo">
        <a :href="room.link">{{ room.title }}</a>
      </h3>
      <div class="location font-bai" v-if="room.camping">
        <i>{{ room.camping.name }}</i>
      </div>
      <div class="des font-bai" v-html="room.description"></div>
      <ul
        class="pro-services list-inline font-bai font-bold"
        v-if="services && services.length"
      >
        <li
          class="item-inline"
          v-for="(service, index) in services"
          :key="index"
        >
          <img v-if="service.icon" :src="service.icon" alt />
          <img v-if="!service.icon" src="../assets/images/picscine.png" alt />
          {{ service.name }}
        </li>
      </ul>
    </div>
    <div class="info-price">
      <div class="time text-center">
        <b>
          <i>{{ getRoomBookTime() }}</i>
        </b>
      </div>
      <div class="price text-center">
        {{ $t("app.à partir de") }}
        <b>{{ getPrice() }} {{ currency.symbol }} / {{ $t("app.nuit") }}</b>
      </div>
      <div class="text-center">
        <a :href="room.link" class="btn font-bold">
          {{ $t("app.en savoir plus") }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get, filter } from "lodash";
import moment from "moment";
import { numberOfNightsBetweenDates } from "@/helper/calculateDays";
export default {
  name: "RoomPlaceListItem",
  props: ["room", "filter"],
  data() {
    return {
      services: []
    };
  },
  computed: {
    ...mapState({
      lang: state => get(state, "app.lang", "fr"),
      currency: state => get(state, "app.currency")
    })
  },
  mounted() {
    this.services = filter(
      get(this.room, "camping.services", []),
      item => item.inclus
    );
  },
  methods: {
    getRoomBookTime() {
      const dateFrom = moment(new Date(this.filter.dateFrom)).format("ddd DD");
      const dateTo = moment(new Date(this.filter.dateTo)).format("ddd DD");
      const totalDate = numberOfNightsBetweenDates(
        moment(new Date(this.filter.dateFrom)),
        moment(new Date(this.filter.dateTo))
      );
      if (totalDate > 1) {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuits")})`;
      }
      return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
        "app.au"
      )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuit")})`;
    },
    getPrice() {
      if (this.currency.code === "MAD") {
        return get(this.room, "price_dh", 0);
      }
      return get(this.room, "price_euro", 0);
    }
  }
};
</script>
